import { useCallback } from 'react'
import { useControlStore } from '@editorStores'

export interface UseResultsSectionOpenResult {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/**
 * Persists a Results2 detail-pane `Section`'s open/collapsed state in the control store, keyed by
 * `sectionId`, so it survives the detail pane remounting when the user switches between elements
 * (see `resultsSectionCollapsed` in controlStore). Spread the result onto `<Section open onOpenChange>`.
 */
const useResultsSectionOpen = (
  sectionId: string,
  defaultOpen = true,
): UseResultsSectionOpenResult => {
  const collapsed = useControlStore(
    state => state.resultsSectionCollapsed[sectionId] ?? !defaultOpen,
  )
  const setResultsSectionCollapsed = useControlStore(state => state.setResultsSectionCollapsed)

  const onOpenChange = useCallback(
    (open: boolean) => setResultsSectionCollapsed(sectionId, !open),
    [sectionId, setResultsSectionCollapsed],
  )

  return { open: !collapsed, onOpenChange }
}

export default useResultsSectionOpen
